import { render } from "./App.vue?vue&type=template&id=3388fe5a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3388fe5a&lang=less"

import exportComponent from "E:\\Zdong\\code\\2026-2-7_后台\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__